import { Plus, WalletCards } from "lucide-react";
import { useAuth } from "../../auth";
import { ROLE_LABELS } from "../../api";

const CRUMBS = {
  dashboard: "Genel Bakış", projects: "Projeler", employers: "İşverenler", subcontractors: "Alt Yükleniciler",
  payments: "Ödemeler", finance: "Finans & Raporlar", import: "Excel İçe Aktar", users: "Kullanıcılar", leave: "İzin & Takvim",
};

export default function Header({ active, onNew, onQuickPay }) {
  const { user, can } = useAuth();
  const initials = (user?.name || "?").split(" ").map((x) => x[0]).join("").slice(0, 2).toUpperCase();
  return (
    <header className="topbar" data-testid="header">
      <div className="crumb">
        <span>Çalışma Alanı</span><b>/</b><strong>{CRUMBS[active]}</strong>
      </div>
      <div className="header-actions">
        <div className="avatar" data-testid="header-avatar">{initials}</div>
        <div className="profile"><b data-testid="header-user-name">{user?.name}</b><span data-testid="header-user-role">{ROLE_LABELS[user?.role]}</span></div>
        {can("admin", "project_manager", "finance") && (
          <button className="quick-pay-btn" onClick={onQuickPay} data-testid="quick-payment-button"><WalletCards size={16} /> Ödeme Kaydet</button>
        )}
        {can("admin", "project_manager") && (
          <button className="new-btn" onClick={onNew} data-testid="new-project-button"><Plus size={17} /> Yeni Proje</button>
        )}
      </div>
    </header>
  );
}
